import clsx from "clsx";
import * as DropdownParts from "../../Dropdown/index.parts";
import { useSelectDropdownContext } from "../root/SelectDropdown.root";
import styling from "./selectOption.module.scss";

export namespace SelectOption {
	export type ElementName = "button";
	export type ElementType = HTMLButtonElement;
	export type Props = DropdownParts.Item.Props;
}

export const SelectOption = (props: SelectOption.Props) => {
	const {
		text,
		children,
		color = "neutral",
		variant = "ghost",
		state,
		onSelectItem,
		...rest
	} = props;
	const { selectedItem, onSelectChange } = useSelectDropdownContext();

	if (selectedItem && selectedItem.id === props.id) {
		return null;
	}

	return (
		<DropdownParts.Item
			className={clsx(styling.item)}
			state={state}
			text={text}
			color={color}
			variant={variant}
			onSelectItem={() => {
				if (props.id !== selectedItem?.id) {
					onSelectChange(props);
				}
			}}
			{...rest}
		>
			{children}
		</DropdownParts.Item>
	);
};
